<template lang="pug">
.activities-location-info-window-list-item.col-xs-12
  .col-xs-6.pr-5
    slot(name="avatar")
    a(@click.prevent="onClick")
      slot(name="name")
  .col-xs-6.justify-content-between
    .info-window-formatted-datetime
      | {{ formattedDatetimeRange }}
    .info-window-footer-duration
      | {{ formattedDuration }}
</template>

<script>
import { ACTIVE_JOB_SITE_TIME_SPAN } from '~/app_constants';
import {
  parseInternalDatetime,
  formatTime,
  formatDatetimeRange,
  formatDuration,
  datetimeWithZone,
} from '~/utils/time_utils';

export default {
  name: 'ActivitiesLocationInfoWindowListItem',
  props: {
    jobSiteVisit: {
      type: Object,
    },
    emitId: {
      type: Number,
    },
    zone: {
      type: String,
    },
  },
  emits: ['click'],
  computed: {
    enterAt() {
      return parseInternalDatetime(this.jobSiteVisit.enter_at);
    },
    exitAt() {
      return parseInternalDatetime(this.jobSiteVisit.exit_at);
    },
    duration() {
      const start = this.enterAt;
      const end = this.exitAt ? this.exitAt : parseInternalDatetime(this.jobSiteVisit.last_seen_at);

      return end.diff(start, 'seconds');
    },
    formattedDatetimeRange() {
      if (this.enterAt && this.exitAt) {
        return formatDatetimeRange(this.enterAt, this.exitAt, {
          style: 'time',
          showSeconds: 'never',
          timezone: this.zone,
        });
      }

      const start = formatTime(this.enterAt, { showSeconds: 'never', timezone: this.zone });
      /**
       * Because we implicitly close visits when we receive new locations that are not
       * in the job site for the visit, we have to assume that if no `exit_at` is present
       * we have to take into account when was the last time that the site was "seen/visited"
       * for the visit in order to compute the new time range.
       *
       * If that value is not present, it means that the visit is still in progress and thus
       * we show "Now" to make it clear that it's still in progress.
       */
      const now = datetimeWithZone(moment(), this.zone);
      const lastSeenAt = datetimeWithZone(this.jobSiteVisit.last_seen_at, this.zone);

      if (now.diff(lastSeenAt, 'minutes') >= ACTIVE_JOB_SITE_TIME_SPAN) {
        return formatDatetimeRange(this.enterAt, lastSeenAt, {
          style: 'time',
          showSeconds: 'never',
          timezone: this.zone,
        });
      }

      return `${start} - Now`;
    },
    formattedDuration() {
      return formatDuration(this.duration, { showSeconds: 'never' });
    },
  },
  methods: {
    onClick() {
      this.$emit('click', this.emitId);
    },
  },
};
</script>
